import {format} from 'date-fns'
import axios from 'axios'
import idx from "idx";

// -------- Request --------

export const getQueryParams = (prefix = '?', filters) => {
    if (!filters) return ''

    const params = new URLSearchParams()

    if (filters.orderBy && filters.orderBy.length > 0) {
        params.append('order', filters.orderBy[0].key)
        if (filters.orderBy[0].value === 'DESC') {
            params.append('descending', true)
        }
    }

    if (filters.filter) {
        filters.filter.forEach((item) => {
            if (item.value) {
                params.append(item.key, item.value)
            }

            if (item.queryKey) {
                params.append(item.queryKey, item.queryValue)
            }
        })
    }

    if (filters.search && filters.search.length > 0 && filters.search[0].value) {
        params.append(filters.search[0].key, filters.search[0].value)
    }

    const pagination = filters.pagination
    if (pagination && pagination.offset !== null && pagination.limit) {
        params.append('limit', pagination.limit)
        params.append('offset', pagination.offset)
    }

    if (filters.dateLimit) {
        params.append('dateLimit', filters.dateLimit.apiDatetime)
    }

    if (filters.active) {
        params.append('activeOnly', true)
    }

    return params.toString() === "" ? "" : (prefix + params.toString())
}

Object.defineProperty(Date.prototype, "apiDatetime", {
    get() {
        return format(this, 'yyyy-MM-dd\'T\'HH:mm:ssxxxx')
    }
})

// -------- Response --------

/// either X-Chirp-Error-Code header or else http response status
export const extractErrorCode = (error, message) => {
    const code = idx(error, _ => _.response.headers["x-chirp-error-code"]) || idx(error, _ => _.response.data.status) || ""
    console.error(message, code, error)
    return code
}

export const getPaginationData = (responseData) => {
    return {
        count: responseData.count,
    }
}

export const paginationFromCount = (count) => {
    return {
        count: count,
    }
}

export const populateUuid = (entity) => {
    entity.uuid = entity.id
    return entity
}

export const populateUuids = (array) => {
    return array.map(_ => populateUuid(_))
}

export default {
    getQueryParams
}



// WEBPACK FOOTER //
// ./src/utils/api.js